import { render, staticRenderFns } from "./DeepRegisterView.vue?vue&type=template&id=f3a8676c&scoped=true&"
import script from "./DeepRegisterView.vue?vue&type=script&lang=js&"
export * from "./DeepRegisterView.vue?vue&type=script&lang=js&"
import style0 from "./DeepRegisterView.vue?vue&type=style&index=0&id=f3a8676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a8676c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow,VSpacer})
